'use strict';

var novicell = novicell || {};

novicell.tabs = novicell.tabs || new function () {
    const tabs = document.querySelectorAll('.js-tabs');
    const itemOpenClass = 'tab--open';
    const winWidth = window.innerWidth;

    this.init = function () {
        if (!tabs || tabs.length <= 0) {
            return;
        }

        for (let i = 0; i < tabs.length; i++) {
            let currentTab = tabs[i];
            let tabsTriggers = currentTab.querySelectorAll('.js-tab-trigger');

            if (!tabsTriggers || tabsTriggers.length <= 0) {
                continue;
            }
            let nodesArray = Array.prototype.slice.call(tabsTriggers);

            //Add open class to first tab on desktop
            if (nodesArray.length) {
                if (winWidth > 992) {
                    nodesArray[0].classList.toggle(itemOpenClass);
                }
            }

            for (let i = 0; i < tabsTriggers.length; i++) {
                let currentTrigger = tabsTriggers[i];

                currentTrigger.addEventListener('click', function (event) {
                    let triggerItem = event.currentTarget;

                    if (novicell.helper.hasClass(triggerItem, itemOpenClass)) {
                        if (winWidth < 992) {
                            triggerItem.classList.remove(itemOpenClass);
                        }
                    } else {
                        /* for (let i = 0; i < tabsTriggers.length; i++) {
                            tabsTriggers[i].classList.remove(itemOpenClass);
                        } */
                        closeTriggersInTab(currentTab);
                        triggerItem.classList.add(itemOpenClass);
                    }
                });
            }
        }
    };
    
    function closeTriggersInTab(tabElm) {
        let tabsTriggers = tabElm.querySelectorAll('.js-tab-trigger');
        for (let i = 0; i < tabsTriggers.length; i++) {
            tabsTriggers[i].classList.remove(itemOpenClass);
        }
    }
};
